import React, {Component} from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './baby-teething.css';
import * as TeethActions from './TeethingActions';
import * as actions from '../Actions';
import Right from '../../right/Right';
import Cookies from 'js-cookie';
import { fetchInitialData } from "../../fetchData";
import Service from '../../service/Service';
import withContext from "../../../withContext";
const service = new Service();

class AddToothDetails extends Component {
    constructor(props) {
        super(props);
        console.log("AddToothDetails props-->",props);
        let initialData = [];
        this.currentY = 0;
        this.currentM = 0;
        var defEruptdate='';
        var defSheddate='';
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData'] && window.__initialData__['initialData']['msg'] == '1') {
            initialData = window.__initialData__['initialData']['result'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData'] && props.staticContext.initialData['initialData']['msg'] == '1') {
                initialData = props.staticContext.initialData['initialData']['result'];
            }
        }
        //console.log("this is initial data->", initialData);
        if (global.ftk !== '') {
            var isLogin = true;
        } else {
            var isLogin = false;
        }
        let childarray = (global.ftk && global.userAry && global.userAry.childData && Array.isArray(global.userAry.childData.UserChildList))
        ? global.userAry.childData.UserChildList
        : [];
              let selectedChlId = Cookies.get('selectedchildID'),
            selectedChlDOB = 0;
        let childAge=0; 
       let selectedChlname  =""; 
    //    console.log(childarray);
            for(let i=0; i<childarray.length; i++){
                if(selectedChlId==childarray[i].ChildId){
                    selectedChlDOB =childarray[i].DOB;
                    childAge = childarray[i].Age;
                    selectedChlname=childarray[i].ChildName;
                    break;
                }
            }
        // if (!childarray[0].IsExpected && childarray.length >= 1) {
        //     selectedChlId = childarray[0].ChildId;
        //     selectedChlDOB = childarray[0].DOB;
        // }
        // else if (childarray[0].IsExpected && childarray.length >= 2) {
        //     selectedChlId = childarray[1].ChildId;
        //     selectedChlDOB = childarray[1].DOB;
        // }
        var _url = props.location.pathname.split("/tools/baby-teething/")[1];
        var path_array = _url.split("-");

        this.state = {
            isLogin: isLogin,
            initialData: initialData,
            thisTooth : Cookies.get('selToothId'),
            selectedChlDOB : 0,
            selectedChlId:  selectedChlId,
            selectedChlDOB : selectedChlDOB,
            childAge:'',
            defEruptdate:'',
            defSheddate:'',
            endDate :'',
            startDate :'',
            selectedChlname:selectedChlname,
            isreadmore:false,
            calenderMaxdate:this.getMaxDate()

        }

    }
    static initialAction(reqUrl, ftk, authData, uId, childData) {

        var header = {
            'Content-Type': 'application/json',
            'ftk': global.ftk,
            'uid': global.uID,
            'access-token': global.accessToken,
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }

        let size = 10;
        if (reqUrl.includes('/page/')) {
            size = parseInt(reqUrl.split('/').pop()) * 10;
        }

        let childarray = childData['UserChildList'];
console.log("[DEBUG] childarray:", childarray);

let selectedChlId = 0;

// ✅ Case 1: If first child is NOT expected and we have at least 1 child → pick first child's ID
if (!childarray[0].IsExpected && childarray.length >= 1) {
    selectedChlId = childarray[0].ChildId;
    console.log("[DEBUG] Selected child from case 1:", selectedChlId);
}
// ✅ Case 2: If first child IS expected and we have at least 2 children → pick second child's ID
else if (childarray[0].IsExpected && childarray.length >= 2) {
    selectedChlId = childarray[1].ChildId;
    console.log("[DEBUG] Selected child from case 2:", selectedChlId);
}

// ⚠️ Override: If a cookie is present → it takes priority over above logic
let cookieChildId = Cookies.get('selectedchildID');
if (cookieChildId) {
    console.log("[DEBUG] Cookie found, overriding selectedChlId:", cookieChildId);
    selectedChlId = cookieChildId;
} else {
    console.log("[DEBUG] No cookie found, keeping selectedChlId:", selectedChlId);
}

let body = JSON.stringify({
    "childId": selectedChlId
});
console.log("[DEBUG] Final request body:", body);

        var url = global.api_url + "teeth/getchildteetheruptiondetail";

        return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {
        document.addEventListener("click", actions.domClick);
        var childarray=[];
        var selectedChlDOB=0;
        var selectedChlId='';
        var childAge='';
        var selectedChlname ="";
        var onlyDate='';
        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && Object.keys(this.state.initialData).length < 1)) {
                service.showLoader();
                childarray = global.userAry['childData']['UserChildList'];
                console.log(childarray);
                selectedChlId =Cookies.get('selectedchildID'),
                selectedChlDOB = 0;                
                for(var i=0; i< childarray.length;i++){
                    if(selectedChlId==childarray[i].ChildId){
                        selectedChlDOB = childarray[i].DOB;
                        childAge = childarray[i].Age;
                        selectedChlname=childarray[i].ChildName;
                        break;
                    }
                }

                // if (!childarray[0].IsExpected && childarray.length >= 1) {
                //     selectedChlId = childarray[0].ChildId;
                //     selectedChlDOB = childarray[0].DOB;
                // }
                // else if (childarray[0].IsExpected && childarray.length >= 2) {
                //     selectedChlId = childarray[1].ChildId;
                //     selectedChlDOB = childarray[1].DOB;
                // }
                // for(i=0; i< childarray.length; i++){
                //     if(this.state.selectedChlId==childarray[i].ChildId){
                //         selectedChlDOB = childarray[i];                       
                //         break;
                //     }
                // }
                for(var i=0; i<this.state.initialData.length; i++){

                    if(this.state.thisTooth == parseInt(this.state.initialData[i].toothId)){
                        if(this.state.initialData[i].toothErruptionDate && !(this.state.initialData[i].toothSheddingDate)){
                            onlyDate = new Date(this.state.initialData[i].toothErruptionDate);
                            var yr = onlyDate.getFullYear();
                            var mn = onlyDate.getMonth() + 1;
                            var dt = onlyDate.getDate();
                            defEruptdate = yr + '/' + mn + '/' + dt;
                            this.setState({defEruptdate:defEruptdate});
                        }else if(this.state.initialData[i].toothSheddingDate){
                            onlyDate = new Date(this.state.initialData[i].toothSheddingDate);
                            var yr = onlyDate.getFullYear();
                            var mn = onlyDate.getMonth() + 1;
                            var dt = onlyDate.getDate();
                            defSheddate = yr + '/' + mn + '/' + dt;
                            this.setState({defSheddate:defSheddate});
                        }        
                       
                        // tipsbreak = ChildTeethData[i].toothTips.replace(/\n/g, "<br>");
                        // tips = tipsbreak.split('<br>');
                        // tipTitle = tips[0].replace("<b>", "").replace("</b>", "");
                    }
                }
                var onlyDate = new Date();
                var endDate = onlyDate.getFullYear() + '-' + (onlyDate.getMonth() + 1) + '-' + onlyDate.getDate();

                var date = this.state.selectedChlDOB.split("-");
                var startDate = date[2] + '-' + TeethActions.monthStrToNum(date[1]) + '-' + date[0];
                this.setState({
                    selectedChlId: Cookies.get('selectedchildID'),
                    selectedChlDOB : selectedChlDOB,
                    thisTooth : Cookies.get('selToothId'),
                    endDate:endDate,
                    startDate:startDate,
                    childAge:childAge,
                    selectedChlname:selectedChlname
                }, () => {
                    this.getErptData(selectedChlId);
                });

                // console.log("child dob->",this.state.selectedChlDOB);

                localStorage.setItem('BabyTeethingDetails', JSON.stringify(this.state.initialData));
            } else if(this.state.initialData || (this.state.initialData && Object.keys(this.state.initialData).length > 1)){
                service.showLoader();
                childarray = global.userAry['childData']['UserChildList'];
                selectedChlId = Cookies.get('selectedchildID');
                    for(var i=0; i< childarray.length;i++){
                        if(parseInt(selectedChlId)==childarray[i].ChildId){
                            selectedChlDOB = childarray[i].DOB;
                            childAge = childarray[i].Age;
                            selectedChlname=childarray[i].ChildName;
                            break;
                        }
                    }
                    for(var i=0; i<this.state.initialData.length; i++){
                        if(parseInt(this.state.thisTooth) == parseInt(this.state.initialData[i].toothId)){
                            if(this.state.initialData[i].toothErruptionDate && !(this.state.initialData[i].toothSheddingDate)){
                                onlyDate = new Date(this.state.initialData[i].toothErruptionDate);
                                var yr = onlyDate.getFullYear();
                                var mn = onlyDate.getMonth() + 1;
                                var dt = onlyDate.getDate();
                                defEruptdate = yr + '/' + mn + '/' + dt;
                                this.setState({defEruptdate:defEruptdate});
                            }else if(this.state.initialData[i].toothSheddingDate){
                                onlyDate = new Date(this.state.initialData[i].toothSheddingDate);
                                var yr = onlyDate.getFullYear();
                                var mn = onlyDate.getMonth() + 1;
                                var dt = onlyDate.getDate();
                                defSheddate = yr + '/' + mn + '/' + dt;
                                this.setState({defSheddate:defSheddate});
                            }
                              break;                  
                            
                            // tipsbreak = ChildTeethData[i].toothTips.replace(/\n/g, "<br>");
                            // tips = tipsbreak.split('<br>');
                            // tipTitle = tips[0].replace("<b>", "").replace("</b>", "");
                        }
                    }
                    var onlyDate = new Date();
                    var endDate = onlyDate.getFullYear() + '-' + (onlyDate.getMonth() + 1) + '-' + onlyDate.getDate();            
                    var date = selectedChlDOB.split("-");
                    var startDate = date[2] + '-' + TeethActions.monthStrToNum(date[1]) + '-' + date[0] ;
                    this.setState({
                        selectedChlId: parseInt(selectedChlId),
                        selectedChlDOB : selectedChlDOB,
                        thisTooth :parseInt(this.state.thisTooth),                        
                        endDate:endDate,
                        startDate:startDate,
                        childAge:childAge,
                        selectedChlname:selectedChlname                  
                    }, () => {
                        this.getErptData(selectedChlId);
                    });
                    // console.log("child dob->",this.state.childAge);
                   
                    localStorage.setItem('BabyTeethingDetails', JSON.stringify(this.state.initialData));

            }else{
                localStorage.setItem('BabyTeethingDetails', JSON.stringify(this.state.initialData));
            }


        } else {
            if (localStorage.getItem('BabyTeethingData')) {
                this.setState({
                    initialData: JSON.parse(localStorage.getItem('BabyTeethingData'))
                });
            }
            service.hideLoader();
        }
    }
    getMaxDate() {
        let cDate = new Date();
        let year = cDate.getFullYear();
        let month = cDate.getMonth() + 1;
        let day = cDate.getDate();
        month = month > 9 ? month : "0" + month;
        day = day > 9 ? day : "0" + day;
        return year + '-' + month + '-' + day;
    }
    getMinDate(date) {            
        let cDate = new Date(date);
        let year = cDate.getFullYear();
        let month = cDate.getMonth() + 1;
        let day = cDate.getDate();
        month = month > 9 ? month : "0" + month;
        day = day > 9 ? day : "0" + day;
        return year + '-' + month + '-' + day;
    }
    getErptData(childId) {
        var postData = {
            "childId": childId
        };
        var url = global.api_ci_url + "BabyTeething/getChildData";
        service.postServiceCall(url, postData).then((json) => {           
            if (json['result']) {
                // console.log("getErptData--->",json['result']);
                this.setState({
                    initialData: json['result']
                });
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
     saveTeethData(childId,toothId,childDOB) {
        if(navigator.onLine){        
            if (global.ftk) {
                service.gardianProfileChk();
                var childId = childId;
                var chlDOB = childDOB;
                var thId = toothId;
                var postData={};
                var thName = document.querySelector('.tooth-nm').innerText;
                var erruptioncomment = document.getElementById('erruptioncomment').value;
                var sheddingcomment = document.getElementById('sheddingcomment').value;
                var sheddingdate = document.querySelector('#teeth-date1').value;
                var erruptiondate = document.querySelector('#teeth-date').value;
                if(sheddingdate!="" && !(erruptiondate)){
                    postData = {
                        "childId":childId,
                        "dateOfBirth":childDOB,
                        "sheddingComment":sheddingcomment,
                        "sheddingToothDate" :sheddingdate,
                        "toothId" :thId,
                        "toothName":thName
                    }
                } else if (erruptiondate != "" && !(sheddingdate)) {
                    postData = {
                        "childId": childId,
                        "dateOfBirth": childDOB,
                        "comment": erruptioncomment,
                        "toothDate": erruptiondate,
                        "toothId": thId,
                        "toothName": thName
                    }
                   
                } else {
                    service.showAlert("Please enter a date");
                    return false;
                }

                var url = global.api_ci_url + "BabyTeething/insertTeethData";
                service.postServiceCall(url, postData).then((json) => {
                    if (json['result'] == "success") {
                        if(erruptiondate){
                            document.querySelector('.test-internet-error .save-success').innerHTML = "Congratulations!!<br>" + this.state.selectedChlname + "’s " + thName + " has erupted";
                        }else{
                            document.querySelector('.test-internet-error .save-success').innerHTML = "Congratulations!!<br>" + this.state.selectedChlname + "’s " + thName + " has shedded";
                        }
                        
                            document.querySelector('.test-internet-error').style.display="block"; 
                            setTimeout(() => {
                            document.querySelector('.test-internet-error').style.display="none";
                            document.getElementById('sheddingcomment').innerHTML="";
                            document.getElementById('erruptioncomment').innerHTML="";
                        }, 3000)
                            this.setState({isshowDetails: false});                      
                            setTimeout(() => {
                        window.history.back();
                    }, 4000)
                    }
                    else{
                        service.showAlert("Please enter a date");
                    }

                }).catch((error) => {
                    console.error(error);
                    service.hideLoader();
                });
                return true;
            } else {

                service.showAlert("Please Login");
                window.location.href = global.loginUrl + '?URL=' + global.currentURL;
                return false;
            }
        }else{
            service.showAlert("Please check your internet connection");
            return false;
        }
    }

    render() {
        var ChildTeethData = this.state.initialData;
        console.log(ChildTeethData);
        var tipsbreak;
        var tips;
        var tipTitle;
        var childcurrAge=''; 
        var fontcolor='#424242';
        var fontcolor1='#424242';
	var gtmAgeId;
        var gtmAgeId1;
        var flag=false;
        var flag1=false;  
        var a =  this.state.childAge.split(" ");
        if(a.indexOf('year')>-1 || a.indexOf('years')>-1 ){
            childcurrAge = parseInt(a[0]) * 12;
            if(a[2]){
                childcurrAge = childcurrAge + parseInt(a[2]); 
            }
        }
        if(childcurrAge < 36){
            fontcolor = "#bfbfbf";
            gtmAgeId = "tooth-details";
            flag = true;
        }else{
            fontcolor1 = "#bfbfbf";
            gtmAgeId1 = "tooth-details";
            flag1 = true;
        }

        return (
            <main className="main-container">
                <Helmet
                    title="Baby Teething Chart, Age, Numbers, Order, Eruption & Shedding Details"
                    meta={[
                        { "name": "description", "content": "Keeping track of your baby’s teeth is indeed a tough task, FirstCry’s baby teething & shedding order chart will help you to know when do babies start teething and what age your child’s tooth erupt & shed." },
                        { "name": "keywords", "content": "Baby Teething,  Baby Teething Chart, Baby Teething Order" },
                        { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title babyteething_title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Baby Teething</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0} aria-label={`Enter Teeth Details ${this.state.isLogin && this.state.selectedChlname ? `for "${this.state.selectedChlname}"` : ''}`}>Enter Teeth Details {(this.state.isLogin && this.state.selectedChlname) ? <span>for "{this.state.selectedChlname}"</span> : null}</h1>
                </div>
                <div className="sub-container left baby-teething-tool">
                    <div className="baby-teething-main data-container left">
                        <div className="add-tooth-details">
                            {ChildTeethData && ChildTeethData.map(teethInfo => 
                                this.state.thisTooth == parseInt(teethInfo.toothId) ? 
                                <div key={teethInfo.toothId} className="add-details" id={gtmAgeId} data-teethtype="Erruption" data-number={teethInfo.toothNumber} data-age={this.state.childAge} data-tname={teethInfo.toothName} data-tmonth={`${teethInfo.startMonth} - ${teethInfo.endMonth} Months`}>
                                    <div className="tooth-name" style={{color:fontcolor1}}>
                                        Tooth Name: <span className="M18_42 tooth-nm" style={{color:fontcolor1}}>{teethInfo.toothName}</span>
                                    </div>
                                    <div className="months" style={{color:fontcolor1}}>{teethInfo.startMonth} - {teethInfo.endMonth} Months</div>
                                    <div className="tooth-date">
                                        <div className="tooth-date-text" style={{color:fontcolor1}}>Date</div>
                                        <label htmlFor="teeth-date">
                                        {teethInfo.toothErruptionDate == '' ?
                                            <input id="teeth-date" placeholder="Select a Date" className="R12_42 date" type="text" defaultValue="" max={this.state.calenderMaxdate} min={this.getMinDate(this.state.selectedChlDOB)} onKeyPress={(e) => service.onKeyPressDate(e)} onFocus={(e) => service.onFocusDate(e)} disabled={flag1}/> : 
                                            <input id="teeth-date" placeholder="Select a Date" className="R12_42 date" type="text" defaultValue={flag1 ? '' : `${new Date(teethInfo.toothErruptionDate).getFullYear()}-${parseInt(new Date(teethInfo.toothErruptionDate).getMonth()+1)}-${new Date(teethInfo.toothErruptionDate).getDate()}`} max={this.state.calenderMaxdate} min={this.getMinDate(this.state.selectedChlDOB)} onKeyPress={(e) => service.onKeyPressDate(e)} onFocus={(e) => service.onFocusDate(e)} disabled={flag1}/>
                                        }
                                            <span data-icon-font="w" className="calender right"></span>
                                        </label>
                                    </div>
                                    <div className="enter-tet-det" style={{color:fontcolor1}}>Please enter tooth eruption details &nbsp;</div>
                                    {/* <span className="R13_9e min-50">(Maximum 250 characters)</span> */}
                                    <textarea placeholder="Write Here" maxLength="250" id="erruptioncomment" className="details-txt" defaultValue={flag1 ? '' : teethInfo.toothErruptionDetails} disabled={flag1}></textarea>

                                    {/* shedding details */}
                                   
                                    <div className="sheddingDet-addinfo" id={gtmAgeId1} data-age={this.state.childAge} data-teethtype="Shedding" data-tname={teethInfo.toothName} data-number={teethInfo.toothNumber} data-tmonth={`${teethInfo.startYear} - ${teethInfo.endYear} Years`}>                                     
                                        <div className="sheddingDet-title" style={{color:fontcolor}}>
                                            Shedding Details
                                        </div>
                                        <div className="tooth-name"  style={{color:fontcolor}}>
                                            Tooth Name: <span className="M18_42 tooth-nm"  style={{color:fontcolor}}>{teethInfo.toothName}</span>
                                        </div>
                                        <div className="months" style={{color:fontcolor}}>{teethInfo.startYear} - {teethInfo.endYear} Years</div>
                                        <div className="tooth-date">                                            
                                            <div className="tooth-date-text"  style={{color:fontcolor}}>Date</div>
                                            <label htmlFor="teeth-date">
                                            {teethInfo.toothSheddingDate ?
                                                <input id="teeth-date1" placeholder="Select a Date" className="R12_42 date" type="text" defaultValue={flag ? '' : `${new Date(teethInfo.toothSheddingDate).getFullYear()}/${parseInt((new Date(teethInfo.toothSheddingDate).getMonth()+1))}/${new Date(teethInfo.toothSheddingDate).getDate()}`} max={this.state.calenderMaxdate} min={this.getMinDate(this.state.selectedChlDOB)} onKeyPress={(e) => service.onKeyPressDate(e)} onFocus={(e) => service.onFocusDate(e)} disabled={flag}/> :
                                                <input id="teeth-date1" placeholder="Select a Date" className="R12_42 date" type="text" defaultValue="" max={this.state.calenderMaxdate} min={this.getMinDate(this.state.selectedChlDOB)} onKeyPress={(e) => service.onKeyPressDate(e)} onFocus={(e) => service.onFocusDate(e)} disabled={flag}/> 
                                               
                                            }
                                                <span data-icon-font="w" className="calender right"></span>
                                            </label>
                                        </div>
                                        <div className="enter-tet-det" style={{color:fontcolor}}>Please enter tooth shedding details &nbsp;</div>
                                        {/* <span className="R13_9e min-50">(Maximum 250 characters)</span> */}
                                        <textarea placeholder="Write Here" maxLength="250"  id="sheddingcomment" className="details-txt" defaultValue={flag ? '': teethInfo.toothsheddingDetails} disabled={flag}></textarea>

                                        <div className="askB_1 save-btn"
                                        onClick={(e) => this.saveTeethData(this.state.selectedChlId, teethInfo.toothId, this.state.selectedChlDOB)}
                                        >
                                            <span className="M14_white devsave">SAVE</span>
                                        </div>
                                        <span id="star-five"></span>
                                        {/* <span>{teethInfo.toothTips}</span> */}
                                    </div>
                                    <div className="teeth-tips M16_42">Tips</div>
                                        <div className="R14_75 toothTips cropTip"><b>{teethInfo && teethInfo.toothTips && teethInfo.toothTips.split('</b>')[0] ? teethInfo.toothTips.split('</b>')[0].replace( /(<([^>]+)>)/ig, '') : ""}</b><br />{teethInfo && teethInfo.toothTips && teethInfo.toothTips.split('</b>')[1] ? teethInfo.toothTips.split('</b>')[1].replace( /(<([^>]+)>)/ig, '') : ""}</div>
                                        {window.innerWidth <= 767 ? teethInfo.toothTips.length > 138 ? <span className="read-more R14_link" onClick={() => TeethActions.readmore(this)}>{this.state.isreadmore ? "Read less" : "Read more"}</span> : null : teethInfo.toothTips.length > 305 ? <span className="read-more R14_link" onClick={() => TeethActions.readmore(this)}>{this.state.isreadmore ? "Read less" : "Read more"}</span> : null
                                    }                               
                                </div> : null
                            )}
                            <div className="test-internet-error">
                                <div className="save-success">
                                 Please check internet connection
                                 </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Right url={this.props.location.pathname} />
            </main>
        )
    }
}

export default withContext(AddToothDetails);
